import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "@/lib/content";

export default function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 blur-xl group-hover:opacity-80 transition-opacity" />
      <span className="relative flex items-center gap-2 bg-[#25D366] hover:bg-[#1DA851] text-white rounded-full pl-4 pr-5 py-3 shadow-lg transition-all duration-300 group-hover:-translate-y-0.5">
        <MessageCircle className="w-5 h-5" />
        <span className="hidden sm:inline text-sm font-medium">Ask on WhatsApp</span>
      </span>
    </a>
  );
}
